(ns com.theplantscape.plant-web.components.tailwind.forms.polycultures
  (:require
   [reagent.core :as r]
   [com.theplantscape.web-ui.tailwind.ensemble :refer [form]]
   [com.theplantscape.plant-web.components.forms.core :refer [update-atom-hm]]
   [com.theplantscape.web-ui.tailwind.form.elements.input :as f]
   [com.theplantscape.plant-web.components.tailwind.buttons
    :refer [button-progress-async]]))

(defn ui-form-create-polyculture [values cfg]
  (let [style "p-2 w-full "
        set-form-value (partial update-atom-hm values)]
    (fn [values cfg]
      [:div.w-full
       (str @values)
       [form
        [:<>
         [:div.grow
          [f/ui-form-input
           (r/cursor values [:values :polyculture|title])
           {:name "polyculture|title"
            :label "Title"
            :tooltip "Title"
            :input-classes (str style " w-full grow")
            :store-fn set-form-value}]]

         [:div.grow
          [f/ui-form-input
           (r/cursor values [:values :polyculture|description])
           {:name "polyculture|description"
            :label "Description"
            :tooltip "Description"
            :input-classes (str style " w-full grow")
            :store-fn set-form-value}]]
         [:div.mt-4
          [button-progress-async
           "Create new polyculture"
           {:on-click (fn [] ((:on-submit cfg) (:values @values)))
            :on-complete (:on-submit-complete cfg)}]]]]])))


